import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import CollectionsBootstrap from 'modules/contracts/lib/ProfileCollectionsBootstrap'
import Cell from 'modules/contracts/pages/ContractVersionsPage/Cell'
import { RouteProvider } from 'modules/contracts/pages/ContractVersionsPage/_RouteContext'
import contractVersions from 'modules/contracts/store/collections/contractVersions'

const Container = observer(() => {
  const { navigation } = useNavigation()

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  if (loading) {
    return <Loading />
  }

  return (
    <RouteProvider
      baseRoute={{
        contractVersionPath: (contractVersionId: string) =>
          navigation.profile.contractVersions.contractVersionId.fullPath({ contractVersionId }),
      }}
    >
      <Cell contractVersions={contractVersions} />
    </RouteProvider>
  )
})

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
